import { render, staticRenderFns } from "./UnitManagement.vue?vue&type=template&id=e9bb489a&"
import script from "./UnitManagement.vue?vue&type=script&lang=js&"
export * from "./UnitManagement.vue?vue&type=script&lang=js&"
import style0 from "./UnitManagement.vue?vue&type=style&index=0&id=e9bb489a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports